import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Symptoms from "./components/Symptoms";
import Causes from "./components/Causes";
import Steps from "./components/Steps";
import QuickCheck from "./components/QuickCheck";
import AddressGuide from "./components/AddressGuide";
import NetworkGuide from "./components/NetworkGuide";
import Safety from "./components/Safety";
import Faq from "./components/Faq";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Symptoms />
        <Causes />
        <Steps />
        <QuickCheck />
        <AddressGuide />
        <NetworkGuide />
        <Safety />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}